/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsChangeMonthlyPayment204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsChangeMonthlyPayment505Schema = z.any();

export const optionsChangeMonthlyPaymentMutationResponseSchema = z.lazy(() => optionsChangeMonthlyPayment204Schema);
